import { render, staticRenderFns } from "./tabReimbursement.vue?vue&type=template&id=4278d1d0&scoped=true"
import script from "./tabReimbursement.vue?vue&type=script&lang=ts"
export * from "./tabReimbursement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4278d1d0",
  null
  
)

export default component.exports